var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.06 24.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-F2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2350466722016",
    "data-name": 2350466722016
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66,24.33H24.45c1.89,0,2.55-.87,2.61-2.62V5.32A2.71,2.71,0,0,0,25.65,3c-1.22-.66-4.06-.15-5.34-.32-.34,0-.78-.58-1-.85a13.43,13.43,0,0,0-2-1.85H9.75c-.49,0-1,.79-1.22,1.06s-.36.33-.54.55C6.85,3,7.08,2.7,5.61,2.7H3.33c-1.62,0-2.49.42-3,1.53C-.15,5.14,0,7.44,0,8.62S-.07,21.51.1,22.24A2.73,2.73,0,0,0,2.66,24.33ZM13,6.8A6.74,6.74,0,1,0,20.28,13,6.73,6.73,0,0,0,13,6.8Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.73,9.27A4.29,4.29,0,0,0,9.3,14.39a4.34,4.34,0,1,0,3.43-5.12Z",
    transform: "translate(0 0)",
    fill: "#b3b3b3",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/F2.c7e5e808f210cbe2281e04d2c3ebccb5.svg";
export { ForwardRef as ReactComponent };